TiposUniGesGridAngCtrl.$inject = ['$log', '$scope', 'TiposUniGesActionsService'];
export default function TiposUniGesGridAngCtrl($log, $scope, TiposUniGesActionsService) {


    $scope.anyadirUsuario = function (idvTUniGes, rol) {
        return TiposUniGesActionsService.addUsuarioToTipo(idvTUniGes, rol)
            .then(function () {
                TiposUniGesGridCtrl.recargarDetallesUsuarios(idvTUniGes);
            });
    };

    $scope.anyadirEntidad = function (idvTUniGes, rol) {
        return TiposUniGesActionsService.addEntidadToTipo(idvTUniGes, rol)
            .then(function () {
                TiposUniGesGridCtrl.recargarDetallesUsuarios(idvTUniGes);
            });
    };

    $scope.anyadirGrupo = function (idvTUniGes, rol) {
        return TiposUniGesActionsService.addGrupoToTipo(idvTUniGes, rol)
            .then(function () {
                TiposUniGesGridCtrl.recargarDetallesUsuarios(idvTUniGes);
            });
    };

}